import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralHowDoReferralsWorkIA = function BrandReferralHowDoReferralsWorkIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_HOW_REFERRALS_WORK_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_HOW_REFERRALS_WORK_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_HOW_REFERRALS_WORK_TITLE = function BRAND_REFERRALS_HOW_REFERRALS_WORK_TITLE(strictLocalize) {
  return strictLocalize({
    id: "Sn+nxa",
    defaultMessage: [{
      "type": 0,
      "value": "Hoe werken merkdoorverwijzingen"
    }]
  });
};
var BRAND_REFERRALS_HOW_REFERRALS_WORK_DESCRIPTION = function BRAND_REFERRALS_HOW_REFERRALS_WORK_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "jj5C04",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt tegoed verdienen als je een merk doorverwijst om op Faire te verkopen. Om in aanmerking te komen voor het tegoed, moet het merk jouw link gebruiken of jou toevoegen als hun doorverwijzer wanneer ze zich registreren. Houd er rekening mee dat jezelf doorverwijzen of mondelinge doorverwijzingen niet in aanmerking komen."
    }]
  });
};